export default __webpack_public_path__ + "static/media/alex_s.c1316d7a.jpg";